import React from "react";

class Perouse extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="painting-item" id="perouse">
                <div className="painting-item-left">
                    <div className="painting-container">
                        <img src='/alphabet-2013/perouse.webp' className="painting-image"></img>
                        <div className="painting-title">
                            La Pérouse
                            <br/>
                            Avril 2013
                        </div>
                    </div>
                </div>
                <div className="painting-item-right">
                    <h3 className="painting-text-subtitle">La Pérouse</h3>
                    <p className="painting-item-text">
                    </p>
                </div>
            </div>
        );
    }

}

export {Perouse};
